import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  data: {
    paymentMethod: null
  }
};

export const slice = createSlice({
  name: 'paymentMethod',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.data = initialState.data;
    },
    setPaymentMethod: (state, { payload }) => {
      state.data.paymentMethod = payload;
    }
  }
});

export const { setPaymentMethod, setInitialState } = slice.actions;

export const selectSlice = (state) => state[slice.name];
export const selectSliceData = (state) => selectSlice(state).data;
export const selectPaymentMethod = (state) =>
  selectSliceData(state).paymentMethod;

export default slice.reducer;
